import { gql } from '@apollo/client';

export const QUERY_DELIVERY_DASHBOARD = gql`
    query QueryDeliveryDashboard($input: DeliveryDashboardQueryInput!) {
        queryDeliveryDashboard(input: $input) {
            timePeriod
            hubId
            warehouseId
            dspId
            sortingCode
            dspName
            arrivedCount
            pickupRate
            deliveredRate
            inboundMissScanRate
            pickup12hRate
            delivered24hRate
            returnUnfinished72hRate
            returnWarehouseNoPickup24hRate
            return_start_count
            return_unfinished_72h_count
            return_warehouse_off_shelf_count
            return_warehouse_no_driver_pickup_24h_count
            undeliveredRate
            undeliveredCount
            unpickupCount
            deliveringCount
            deliveryFailedCount
            returnCount
            lostDamagedCount
            delivered36hRate
            delivered36hCount
            noUpdate72hRate
            noUpdate72hWarehouseRate
            noUpdate72hDriverRate
            noUpdate72hCount
            noUpdate72hWarehouseCount
            noUpdate72hDriverCount
            noUpdate120hRate
            noUpdate120hWarehouseRate
            noUpdate120hDriverRate
            noUpdate120hCount
            noUpdate120hWarehouseCount
            noUpdate120hDriverCount
            driverSideCount
            driverSideRate
            warehouseSideCount
            warehouseSideRate
            handoverDiffCount
            handoverDiffRate
            returnUndeliveredCount
            returnUndeliveredRate
        }
    }
`;

export const QUERY_DELIVERY_DASHBOARD_SUMMARY = gql`
    query QueryDeliveryDashboardSummary($input: DeliveryDashboardQueryInput!) {
        queryDeliveryDashboardSummary(input: $input) {
            calculatedAt
            items {
                hubId
                warehouseId
                sortingCode
                arrivedCount
                undeliveredRate
                undeliveredCount
                unpickupCount
                deliveringCount
                returnCount
                lostDamagedCount
                deliveryFailedCount
                noUpdate72hCount
                noUpdate72hRate
                noUpdate72hWarehouseCount
                noUpdate72hWarehouseRate
                noUpdate72hDriverCount
                noUpdate72hDriverRate
                driverSideCount
                driverSideRate
                warehouseSideCount
                warehouseSideRate
                handoverDiffCount
                handoverDiffRate
                returnUndeliveredCount
                returnUndeliveredRate
            }
        }
    }
`;
